/**
 * Feature flag string keys returned in `activeFeatureFlags` from PublicProductRpc.
 *
 * These are plain strings — NOT hub-http gate objects — because the public
 * feature-flags API returns a flat string array, not portal gate IDs.
 *
 * Usage: `featureFlags.includes(FeatureFlags.HUBSPOT_ON_CREDITS)`.
 */
export const FeatureFlags = {
  /** Portal is on the HubSpot-on-Credits v1 billing model. */
  HUBSPOT_ON_CREDITS: 'hubspotoncredits',
  /** Portal is on the HubSpot-on-Credits v2 billing model. */
  HUBSPOT_ON_CREDITS_V2: 'hubspotoncreditsv2',
  /** Portal has seats-based billing enabled. */
  SEATS: 'seats',
  /** Enables JSON-LD schema markup emission on public pricing pages. */
  PUBLIC_PRICING_PAGE_SCHEMA: 'PUBLIC_PRICING_PAGE_SCHEMA',
  /** Shows the redesigned payment options comparison section on the public commerce page. */
  PUBLIC_PAYMENT_OPTIONS_NEW: 'PUBLIC_PAYMENT_OPTIONS_NEW',
  /**
   * Shows the "Help me choose" plan-quiz entry point on the HSOC v2 pricing
   * page. Public counterpart of the in-app PPFE::HelpMeChoose gate; off by
   * default.
   */
  PRICING_PAGE_HELP_ME_CHOOSE: 'PRICING_PAGE_HELP_ME_CHOOSE'
};